import { render, staticRenderFns } from "./Tzsyck.vue?vue&type=template&id=213f5ef7&scoped=true&"
import script from "./Tzsyck.vue?vue&type=script&lang=js&"
export * from "./Tzsyck.vue?vue&type=script&lang=js&"
import style0 from "./Tzsyck.vue?vue&type=style&index=0&id=213f5ef7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213f5ef7",
  null
  
)

export default component.exports